import type { TodoItem } from '@/components/Worlds/Todos/types'

import useSATBootcampLearnerTodos from './useSATBootcampLearnerTodos'
import useSATBootcampTutorTodos from './useSATBootcampTutorTodos'

export default function useSATBootcampTodos(): TodoItem[] {
  const learnerTodos = useSATBootcampLearnerTodos()
  const tutorTodos = useSATBootcampTutorTodos()

  return [...tutorTodos, ...learnerTodos]
}
